module.exports = __webpack_public_path__ + "img/bg-brandetail.0c4439aa.png";